module.exports = __webpack_public_path__ + "img/Eezywork.1dabb0a.png";